// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"pricing","163":"map","920":"forbussines"}[chunkId] + "." + {"47":"ad6c9016","163":"21b05fd9","920":"21ff7dad"}[chunkId] + ".css";
};